export const GET_PUBLICITY_ALL = `
    query {
    getPublicityAll {
        message
        publicity {
            id
            descriptionPublicity
            logo
            commercialName
            link
            startDate
            finishDate
            status
            id_category
            category {
                id
                description
            }
        }
    }
}
`;

export const GET_LIST_CATEGORY = `
    query {
        getAllCategory {
            id
            description
            entity_type
            code
        }
    }
`;

export const SERCH_GET_PUBLICITY = `
    query ($searchParameter: JSON) {
        searchPublicity(searchParameter: $searchParameter) {
        message
        publicity {
            id
            descriptionPublicity
            commercialName
            link
            logo
            startDate
            finishDate
            status
            id_category
            category {
                id
                description
            }
        }
        }
    }   
`;

export const GET_PUBLICITY_ID = `
    query ($id: ID) {
          getPublicityId(id: $id) {
                message
                publicity {
                    id
                    descriptionPublicity
                    commercialName
                    link
                    logo
                    startDate
                    finishDate
                    category {
                        description
                    }
                }
          }
    }
`;